import {
  ACTION_ADD_SITE_TEXTS_CONFIG,
  ACTION_ADD_SITE_TEXTS_TRANSLATIONS,
  ACTION_ADD_SITE_TEXTS_DEFAULT_TRANSLATIONS,
} from '../actionTypes';


export const actionAddSiteTextsConfig = config => ({
  type: ACTION_ADD_SITE_TEXTS_CONFIG,
  payload: { config },
});

export const actionAddSiteTextsTranslations = translations => ({
  type: ACTION_ADD_SITE_TEXTS_TRANSLATIONS,
  payload: { translations },
});

export const actionAddSiteTextsDefaultTranslations = translations => ({
  type: ACTION_ADD_SITE_TEXTS_DEFAULT_TRANSLATIONS,
  payload: { translations },
});
